import React, { Component } from "react";
import styled from "styled-components";
import nota from "../../Global/nota.guidelines.json";

import { Card } from "./Card.js";

const multiple = nota.global.multiple;

const StyledCardPdf = styled.div`
  padding: 0 8px;
  p {
    font-size: 10px;
  }
  h2 {
    font-size: 15px;
  }
  h3 {
    font-size: 12px;
  }
  h5 {
    font-size: 12px;
  }

  /* COLUMNS */
  .column {
    margin-bottom: 8px;
  }
  .leftColumn {
    width: 60%;
  }
  .rightColumn {
    width: 40%;
  }

  /* PROGRAMME IMAGE BLOCK */
  .headerCard {
    padding-top: 0;
  }

  .headerCard {
    .editCardBtnWrapper {
      display: none;
    }
  }

  /* HOT FACTORS BLOCK */
  .hotFactorsWrapper {
    padding-top: 0;
    margin-bottom: 8px;
    .btnsWrapper {
      display: none;
    }
  }

  /* GENRE CONCEPT BLOCK */
  .blockInfoWrapper {
    padding-top: 0;
  }
  .blockInfoWrapper {
    .headerBlockWrapper {
      .btnsWrapper {
        display: none;
      }
    }
  }

  /* COUNTRY BLOCK */
  .asideBlocksWrapper {
    flex-direction: column;
  }
  .leftAsideBlock {
    .topBlock {
      padding: 8px;
    }
  }
  .launchInfoWrapper {
    padding: 8px;
  }
  .rightAsideBlock {
    padding-left: 8px;
  }

  /* FORMAT TYPE BLOCK */
  .formatWrapper {
    flex-direction: column;
  }

  /* KEYWORDS DESCRIPTION BLOCK */
  .keywordsDescriptionBlock {
    .wrapperList {
      .listRow {
        padding: 8px;
      }
    }
    .listLineWrapper {
      flex-direction: column;
      padding: 4px 8px;
      .titleLineWrapper {
        width: 100%;
      }
      .infoLineWrapper {
        padding-left: 0;
      }
    }
  }

  /* INTERNATIONAL FLOW BLOCK */
  .internationalFlowBlock {
    display: -webkit-box;
    page-break-inside: avoid;
  }

  .internationalFlow {
    margin-bottom: 8px;
    .titleWrapper {
      .primaryTitleWrapper {
        width: auto;
      }
    }
  }

  /* AUDIENCE RESULTS BLOCK */
  .audienceResultsTable {
    margin-bottom: 8px;
    .titleWrapper {
      .iconWrapper {
        display: none;
      }
    }
    .titleWrapper {
      .primaryTitleWrapper {
        width: auto;
      }
    }
  }

  /* ENVIRONMENT FOR THE PREMIERE BLOCK */
  .enviromentBlock,
  .evaluationBlock,
  .verdictBlock {
    margin-bottom: 8px;
  }

  .linkWrapper {
    color: ${nota.color.main.default};
    .linkText {
      display: none;
    }
    &::after {
      content: attr(href);
      font-size: 10px;
    }
  }

  /* INFORMATION REQUEST BUTTON */
  .requestInfoBtnWrapper {
    display: none;
  }
`;

export class CardPdf extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <StyledCardPdf>
        {/* <NanoFlex className="logoWrapper" justifyContent={"flex-end"}>
          <NotaLogo />
        </NanoFlex> */}
        <Card render={this.props.render} />
      </StyledCardPdf>
    );
  }
}
